/* eslint-disable react-hooks/exhaustive-deps */
import React, {
    useCallback, useEffect
} from 'react';
import _ from 'lodash';
import { WizardPage, wizardProps } from '@xengage/gw-portals-wizard-react';
import { ViewModelForm } from '@xengage/gw-portals-viewmodel-react';
import { useValidation } from '@xengage/gw-portals-validation-react';
import { readViewModelValue } from '@xengage/gw-jutro-adapters-react';
import { useUpdateSubmissionServices, validationUtil } from 'premier-capability-hooks';
import { withRouter } from 'react-router-dom';
import { PremierConstants } from 'premier-constant-service';
import presentationMetadata from "gw-capability-gateway-quoteandbind-PremierEL-react/config/PremierEL-wizard-config.json5";
import ProductsCoverageSelectionComponent from '../../components/EnvImpairment/ProductsCoverageSelection/ProductsCoverageSelectionComponent'
import UnderwritingInformationComponent from '../../components/EnvImpairment/UnderwritingInformation/UnderwritingInformationComponent'
import MaterialsWasteAndTransComponent from '../../components/EnvImpairment/MaterialsWasteAndTransportation/MaterialsWasteAndTransComponent'
import StorageTanksComponent from '../../components/EnvImpairment/StorageTanks/StorageTanksComponent'
import metadata from './EnvEmpairmentPage.metadata.json5';
import styles from './EnvEmpairmentPage.module.scss';


function EnvEmpairmentPage(props) {
    const { wizardData: submissionVM, updateWizardData, changeNextSteps, steps } = props;
    const { updateSubmission } = useUpdateSubmissionServices();
    const { lineName } = PremierConstants;
    const propertySteps = _.filter(_.get(presentationMetadata, [`${submissionVM.value.baseData.productCode}.default.wizard`, 'steps']), (wizardStep) => wizardStep.id.includes('coveredlocations'))

    const {
        onValidate,
        initialValidation
    } = useValidation('EnvEmpairmentPage');

    useEffect(() => {

    }, []);

    const onNext = useCallback(
        async () => {

            if (!_.isUndefined(submissionVM.value.lobData.envLin.coverables.envImpairmentCoverable.productsCoverageSelection.productType)
                && submissionVM.value.lobData.envLin.coverables.envImpairmentCoverable.productsCoverageSelection.productType === 'EY_EnvImLia') {
                if (_.filter(steps, (step) => step.id === 'coveredlocations').length === 0) {
                    if( submissionVM.value.baseData.jobType === 'PolicyChange') {
                        steps.splice(3, 0, propertySteps[0]);
                        changeNextSteps(steps.slice(3, 12))
                    } else {
                        steps.splice(3, 0, propertySteps[0]);
                        changeNextSteps(steps.slice(4, 12))
                    }
                }
            } else {
                // eslint-disable-next-line no-lonely-if
                if (_.filter(steps, (step) => step.id === 'coveredlocations').length !== 0) {
                    if( submissionVM.value.baseData.jobType === 'PolicyChange') {
                        changeNextSteps(_.filter(steps, (step) => !step.id.includes('coveredlocations')).slice(3, 11))
                    } else {
                        changeNextSteps(_.filter(steps, (step) => !step.id.includes('coveredlocations')).slice(4, 11))
                    }
                }
            }

            const productCode = _.get(submissionVM.value, 'baseData.productCode');
            // eslint-disable-next-line security/detect-object-injection
            const lobLineName = productCode ? lineName[productCode] : '';
            const response = await updateSubmission(lobLineName, 'EnvEmpairmentPage', submissionVM);

            submissionVM.value = response;

            return submissionVM;
        },
        [submissionVM]
    );

    const overrideProps = {
        productsCoverageSelectionComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.envLin.coverables.envImpairmentCoverable.productsCoverageSelection"
        },
        underwritingInformationComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.envLin.coverables.envImpairmentCoverable.underwritingInformation"
        },
        materialsWasteAndTransComponent: {
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.envLin.coverables.envImpairmentCoverable.materialsWasteAndTransDTO"
        },
        storageTanksComponent:{
            overrideProps: {
                "@field": {
                    // apply to all fields
                    showRequired: true,
                    labelPosition: "left",
                },
            },
            visible: _.get(submissionVM, 'lobData.envLin.coverables.envImpairmentCoverable.productsCoverageSelection.productType.value.code') === 'EY_EnvImpLiaStoTan',
            submissionVM,
            updateWizardData,
            pathUpdated: "lobData.envLin.coverables.envImpairmentCoverable.storageTanks",
        },
        // ...materialsWasteAndTransOverrides
    };

    const resolvers = {
        resolveCallbackMap: {
            onValidate
        },
        resolveComponentMap: {
            productsCoverageSelectionComponent: ProductsCoverageSelectionComponent,
            underwritingInformationComponent: UnderwritingInformationComponent,
            materialsWasteAndTransComponent: MaterialsWasteAndTransComponent,
            storageTanksComponent: StorageTanksComponent,
        },
        resolveClassNameMap: styles
    };

    const readValue = useCallback(
        (id, path) => readViewModelValue(metadata.pageContent, submissionVM, id, path, overrideProps),
        [metadata.pageContent, submissionVM, overrideProps]
    );

    const onSave = useCallback(
        async () => {
            const subVMCopy = _.clone(submissionVM);
            const productCode = _.get(subVMCopy.value, 'baseData.productCode');
            
            validationUtil.unSetIsValidationReqFlag(subVMCopy?.lobData?.envLin?.coverables?.envImpairmentCoverable?.value, ' ');

            const lobLineName = productCode ? lineName[productCode] : '';
            await updateSubmission(lobLineName, 'EnvEmpairmentPage', subVMCopy);

            return submissionVM;
        },
        [submissionVM]
    );

    const isDisableNext = () => !submissionVM.lobData.envLin.coverables.envImpairmentCoverable.aspects.subtreeValid

    return (
        <WizardPage onNext={onNext} onSave={onSave} skipWhen={initialValidation} disableNext={isDisableNext()}>
            <ViewModelForm
                uiProps={metadata.pageContent}
                model={submissionVM}
                onModelChange={updateWizardData}
                overrideProps={overrideProps}
                onValidationChange={onValidate}
                resolveValue={readValue}
                callbackMap={resolvers.resolveCallbackMap}
                componentMap={resolvers.resolveComponentMap}
                classNameMap={resolvers.resolveClassNameMap}
            />
        </WizardPage>
    );
}

EnvEmpairmentPage.propTypes = wizardProps;
export default withRouter(EnvEmpairmentPage);
